import * as React from 'react';

function SvgDownArrow(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={12.035} height={7.07} {...props}>
      <g data-name="Group 17">
        <path
          d="M6.015 4.69l4.5-4.5a.66.66 0 01.931 0l.394.395a.659.659 0 010 .931L6.479 6.877a.664.664 0 01-.934 0L.19 1.521a.659.659 0 010-.931L.584.196a.659.659 0 01.931 0z"
          data-name="Path 138"
          fill="#fff"
        />
      </g>
    </svg>
  );
}

export default SvgDownArrow;
